module.exports = __webpack_public_path__ + "images/emoji/flipper.056198352af18806b161.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/flipper.png
// module id = f8d3
// module chunks = 13